<h5 mat-dialog-title i18n>Dealer Latest Login Report</h5>
<div mat-dialog-content>
  <p i18n>Please define the filters below</p>
</div>
<form #parameterForm="ngForm" (ngSubmit)="runReport(parameterForm)">
  <div class="form-group row">
    <div class="col-sm-6">
      <div class="control-wrapper">
        <label for="dealer_ID" class="col-sm-3 col-form-label" i18n>Dealer</label>
        <select name="dealer_ID" id="dealer_ID"
                [(ngModel)]="data.dealerLogin.dealer_ID" #dealer_ID="ngModel"
                class="form-control select-bidit">
          <option [ngValue]="null" i18n>All</option>
          <option *ngFor="let dealer of data.dealers" [ngValue]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
        </select>
      </div>
      <div class="control-wrapper">
        <label for="status" class="col-sm-3 col-form-label" i18n>Status</label>
        <select name="status" id="status"
                [(ngModel)]="data.dealerLogin.status" #status="ngModel"
                class="form-control select-bidit">
          <option [ngValue]="null" i18n>All</option>
          <option [ngValue]=1 i18n>Active</option>
          <option [ngValue]=0 i18n>Inactive</option>
        </select>
      </div>
    </div> 
  </div>
  <div class="form-group">
    <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
    <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
  </div>
</form>

